import React from 'react'
import styled from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'
import { clTransform } from 'src/utils/cloudinary'

export type HeaderClipperWaveVariant =
  | 'curva-scemplice-verso-basso'
  | 'curva-scemplice-verso-alto'

export type HeaderClipperBgPosition = 'top' | 'bottom' | 'center'

interface Props {
  bgImage?: string
  bgSize?: 'cover' | 'contain'
  bgColor?: string
  bgPosition?: string
  bgDesktop?: string
  className?: string
  waveVariant?: HeaderClipperWaveVariant
}

export const HeaderClipper: React.FC<Props> = ({
  bgImage,
  children,
  bgSize,
  bgColor,
  bgPosition,
  bgDesktop,
  className,
  waveVariant = 'curva-scemplice-verso-basso',
}) => {
  return (
    <ShapeContainer className={className}>
      <Path>
        <clipPath
          id='curva-scemplice-verso-basso'
          clipPathUnits='objectBoundingBox'
        >
          <path
            className='wave-lg'
            d='M0,0 v0.945 C0.099,0.976,0.295,1,0.472,1 c0.187,0,0.416,-0.027,0.528,-0.06 V0 H0'
          ></path>
          <path
            className='wave-xs'
            d='M0,-0.001 V0.992 C0.143,0.996,0.291,0.999,0.434,0.999 c0.181,0,0.378,-0.004,0.566,-0.011 V-0.001'
          ></path>
        </clipPath>
      </Path>

      <Path>
        <clipPath
          id='curva-scemplice-verso-alto'
          clipPathUnits='objectBoundingBox'
        >
          <path
            className='wave-lg'
            d='M0,0 V1 c0.083,-0.012,0.181,-0.027,0.292,-0.036 c0.067,-0.006,0.139,-0.01,0.216,-0.01 c0.05,0,0.122,0.001,0.201,0.004 c0.094,0.003,0.199,0.008,0.292,0.015 V0'
          ></path>
          <path
            className='wave-xs'
            d='M0,0 V1 C0.147,0.985,0.318,0.97,0.51,0.97 c0.112,0,0.305,0.004,0.49,0.012 V0'
          ></path>
        </clipPath>
      </Path>

      <Clip waveVariant={waveVariant}>
        <BackgroundWrapper
          bgImage={clTransform({ url: bgImage || '' })}
          bgSize={bgSize}
          bgColor={bgColor}
          bgPosition={bgPosition}
          bgDesktop={bgDesktop}
        >
          <Wrapper>{children}</Wrapper>
        </BackgroundWrapper>
      </Clip>
    </ShapeContainer>
  )
}

export const headerClipperOffset = '-170px'

const ShapeContainer = styled.div`
  margin-top: ${headerClipperOffset};
`

const Path = styled.svg`
  position: absolute;
  width: 0;
  height: 0;

  .wave-lg {
    display: none;
    @media (min-width: ${themeEstra.bp.desktop}) {
      display: block;
    }
  }

  .wave-xs {
    @media (min-width: ${themeEstra.bp.desktop}) {
      display: none;
    }
  }
`

interface ClipProps {
  waveVariant: HeaderClipperWaveVariant
}

const Clip = styled.div<ClipProps>`
  width: 100%;
  background: ${({ theme }) => theme.pageTheme.bg2};
  clip-path: url("#${({ waveVariant }) => waveVariant}");
`

const BackgroundWrapper = styled.div<Partial<Props>>`
  background-image: url(${({ bgImage }) => bgImage});
  background-size: ${({ bgSize }) => bgSize};
  background-position: ${({ bgPosition }) => bgPosition || 'top center'};
  background-color: ${({ bgColor }) => bgColor};
  background-repeat: no-repeat;
  @media (min-width: ${themeEstra.bp.desktop}) {
    background: ${({ bgDesktop }) => bgDesktop};
  }
`

const Wrapper = styled.div`
  position: relative;
  padding-top: 11rem;
  padding-bottom: 2rem;
  @media (min-width: ${themeEstra.bp.tablet}) {
    /* Goes behind top menu */
    padding-top: calc(170px + 1.75rem);
    padding-bottom: 5rem;
  }
`
